import Drawer from '@components/Drawer/Drawer.component'
import Button from 'parkdepot-shared/components/Buttons/Button'
import React, { FC, useState } from 'react'
import {
    Container,
    Subtitle,
    Title,
    MainContent,
    IconContainer,
    AdvantageLine,
    CheckmarkIcon
} from './PaymentAdvertisement.style'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { registerRoute } from '@views/Register/route.const'
import { WemoloIcon } from 'parkdepot-shared/assets/icons'
import {
    LOCAL_STORAGE_getSignupBannerShown,
    LOCAL_STORAGE_setSignupBannerShown
} from '@localStorage/signupBannerShown.localStorage'

interface Props {
    onButtonClick: () => void
}

const PaymentAdvertisementContent: FC<Props> = ({ onButtonClick }) => {
    const { t } = useTranslation()
    const reasons: string[] = t('accountCreationAd.reasons', { returnObjects: true })

    return (
        <Container>
            <MainContent>
                <Title>{t('accountCreationAd.title')}</Title>
                <IconContainer>
                    <WemoloIcon />
                </IconContainer>
                <Subtitle>{t('accountCreationAd.subtitle')}</Subtitle>
                {Array.isArray(reasons) &&
                    reasons.map((reason, index) => (
                        <AdvantageLine key={index}>
                            <CheckmarkIcon className="wemolo-check" />
                            <Subtitle>{reason}</Subtitle>
                        </AdvantageLine>
                    ))}
            </MainContent>
            <Button
                id="account-creation-button"
                $kind={BUTTON_KIND.primary}
                onClick={onButtonClick}
                $size={BUTTON_SIZE.medium}
            >
                {t('accountCreationAd.button')}
            </Button>
        </Container>
    )
}

const PaymentAdvertisement = () => {
    const [isOpen, setIsOpen] = useState(true)
    const history = useHistory()
    const bannerShown = LOCAL_STORAGE_getSignupBannerShown()

    if (bannerShown) {
        return null
    }

    const onButtonClick = () => {
        LOCAL_STORAGE_setSignupBannerShown(true)
        setIsOpen(false)
        history.push(registerRoute())
    }

    return (
        <Drawer
            isOpen={isOpen}
            content={<PaymentAdvertisementContent onButtonClick={onButtonClick} />}
            onClose={() => {
                LOCAL_STORAGE_setSignupBannerShown(true)
                setIsOpen(false)
            }}
        />
    )
}

export default PaymentAdvertisement
